
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/native-delivery/personalization",
      function () {
        return require("private-next-pages/native-delivery/personalization.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/native-delivery/personalization"])
      });
    }
  